/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';

import { StyledButton } from '../../../assets/styles/styles';
import { StyleGridVoucher } from './styles';
import iconStamp from '../../../assets/img/icon-stamp.svg';
// import { toCurrencyFormat } from '../../../../domain/utils/utilitarios-frontend-coopeuch/currency';
import { formatRut, RutFormat, formatNamePreserveAccents, formatDateToLongSpanish } from '../../../../domain/utils/utilitarios-frontend-coopeuch/rut';

const CardVoucherTwo = (props) => {
    const {
        detailData,
        monthlyFees,
        amountMonthlyFees,
        transactionDateTimeLong,
        isMobileDevice,
        onDownloadComponentPdf,
    } = props;

    const refVoucher = useRef(null);
    /* istanbul ignore next */
    const directionData = detailData?.directionDespacho
        ? JSON.parse(detailData.directionDespacho)
        : {};
    // const abono = sessionStorage.getItem('abono');
    /* istanbul ignore next */
    return (
        <StyleGridVoucher>
            <section id="voucherComponente" ref={refVoucher}>
                <SimpleCard
                    contentHeader={
                        <section className="d-flex justify-content-between align-items-center w-100">
                            <article className="d-flex flex-column flex-grow-1">
                                <p className="simplecard__title">Comprobante</p>
                            </article>
                            <StyledButton
                                className="w-auto p-0 min-height-32"
                                type="button"
                                onClick={() =>
                                    onDownloadComponentPdf(/* refVoucher */ 'voucherComponente', 'comprobante')
                                }
                                disabled={false}
                                prefix="line-download-2"
                                variant="text"
                                sizeIcon="18"
                            >
                                {!isMobileDevice && 'Descargar'}
                            </StyledButton>
                        </section>
                    }
                    disabled={false}
                >
                    <Grid className="px-0 pb-2 d-flex flex-column">
                        <Grid className="p-4 px-md-6 py-4">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                <p className="text-color-38 font-size-18 font-weight-bold line-height-24 mr-2 pb-1">
                                    Nuevo(a) socio(a) de Coopeuch
                                </p>
                            </section>

                        </Grid>

                        <Grid className="p-4 px-md-6 gray-section py-4">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                <p className="text-color-38 font-weight-bold font-size-18line-height-24 mr-2 pb-1">
                                    Nombre
                                    <span className="span_1">{formatNamePreserveAccents(detailData?.fullname || '')}</span>
                                </p>
                            </section>
                        </Grid>

                        <Grid className="p-4 px-md-6 white-section py-4">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                <p className="text-color-38 font-weight-bold font-size-18line-height-24 mr-2 pb-1">
                                    Rut
                                    <span className="span_2">{formatRut(detailData?.rut, RutFormat.DOTS_DASH)}</span>
                                </p>
                            </section>
                        </Grid>

                        <Grid className="p-4 px-md-6 gray-section py-4">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                <p className="text-color-38 font-size-18line-height-24 mr-2 pb-1">
                                    Cuotas mensuales pactadas
                                    <span className="span_3">{monthlyFees}</span>
                                </p>
                            </section>
                        </Grid>

                        <Grid className="p-4 px-md-6 white-section py-4">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                <p className="text-color-38 font-size-18line-height-24 mr-2 pb-1">
                                    Valor cuotas mensuales
                                    <span className="span_4">{amountMonthlyFees}</span>
                                </p>
                            </section>
                        </Grid>

                        <Grid className="p-4 px-md-6 gray-section py-4">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                <p className="text-color-38 font-size-18line-height-24 mr-2 pb-1">
                                    Medio de pago primera inversión
                                    <span className="span_9">WebPay Plus</span>
                                </p>
                            </section>
                        </Grid>

                        <Grid className="p-4 px-md-6 white-section py-4">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                <p className="text-color-38 font-size-18line-height-24 mr-2 pb-1">
                                    Medio de pago inversión mensual
                                    <span className="span_9">Pago automático en tu Cuenta Vista (PAC)</span>
                                </p>
                            </section>
                        </Grid>

                        <Grid className="p-4 px-md-6 gray-section py-4">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                <p className="text-color-38 font-size-18line-height-24 mr-2 pb-1">
                                    Tipo de transacción
                                    <span className="span_10">
                                        {detailData?.paymentType} **** {detailData?.lastDigitsCard}
                                    </span>
                                </p>
                            </section>
                        </Grid>
                        <Grid className="p-4 px-md-6 white-section py-4 border-neutral-20 border-bottom">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                <p className="text-color-38 font-size-18line-height-24 mr-2 pb-1">
                                    Código de autorización
                                    <span className="span_11">{detailData?.authorizationCode}</span>
                                </p>
                            </section>
                        </Grid>

                        <Grid className="p-4 px-md-6 py-4">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                <p className="text-color-38 font-size-18 font-weight-bold line-height-24 mr-2 pb-1">
                                    Tu cuenta Vista Coopeuch
                                </p>
                            </section>
                        </Grid>

                        <Grid className="p-4 px-md-6 gray-section py-4">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                {detailData?.tipoEntrega === "domicilio" && (
                                    <p className="text-color-38 font-size-18line-height-24 mr-2 pb-1">
                                        Dirección de despacho
                                        <span className="span_6">{`${directionData?.street || ''} ${directionData?.numeration || ''}, ${directionData?.commune || ''}, ${directionData?.country || ''}`}</span>
                                    </p>
                                )}
                                {detailData?.tipoEntrega === "sucursal" && (
                                    <p className="text-color-38 font-size-18line-height-24 mr-2 pb-1">
                                        Sucursal de retiro
                                        <span className="span_6_1">{formatNamePreserveAccents(sessionStorage.getItem('commune-preferred-office'))} {formatNamePreserveAccents(detailData?.office || '')}</span>
                                    </p>
                                )}
                            </section>
                        </Grid>

                        <Grid className="p-4 px-md-6 white-section py-4 border-neutral-20">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                {detailData?.tipoEntrega === "domicilio" && (
                                    <p className="text-color-38 font-size-18line-height-24 mr-2 pb-1">
                                        Fecha de entrega
                                        <span className="span_7">{formatDateToLongSpanish(detailData?.dayScheduling || '')} {detailData?.hourDespacho || ''}</span>
                                    </p>
                                )}
                                {detailData?.tipoEntrega === "sucursal" && (
                                    <p className="text-color-38 font-size-18line-height-24 mr-2 pb-1">
                                        Fecha de retiro
                                        <span className="span_7_1">{`Retiro disponible a contar de 3 días hábiles.`}</span>
                                    </p>
                                )}
                            </section>
                        </Grid>

                        {/* <Grid className="p-4 px-md-6 gray-section py-4">
                            <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                                <p className="text-color-38 font-size-18line-height-24 mr-2 pb-1">
                                    Monto abono de activación
                                    <span className="span_12">
                                       {abono ? toCurrencyFormat(abono) : '$1.000'}
                                    </span>
                                </p>
                            </section>
                        </Grid> */}
 
                        <Grid className="p-4 px-md-6 d-flex flex-column flex-md-row justify-content-between">
                            <article className="d-flex flex-column justify-content-center">
                                <p className="line-height-20">
                                    Fecha y hora: <strong>{transactionDateTimeLong}.</strong>
                                </p>
                            </article>
                            <article className="d-flex align-items-center flex-row flex-md-row-reverse">
                                <img
                                    className={`${!isMobileDevice ? 'img-stamp' : ''} mr-2 mr-md-0 ml-0 ml-md-2`}
                                    src={iconStamp}
                                    width="100px"
                                    height="100px"
                                    alt="stamp-icon"
                                />
                                <p className="font-size-12 text-color-A5">Transferencias 100% seguras</p>
                            </article>
                        </Grid>
                    </Grid>
                </SimpleCard>
            </section>
        </StyleGridVoucher>

    );
};
/* istanbul ignore next */
CardVoucherTwo.defaultProps = {
    accountCreationDate: '',
    isMobileDevice: false,
    onScrollTo: () => null,
    onDownloadContracts: () => null,
    onDownloadComponentPdf: () => null,
    onCallSurvey: () => null,
};
CardVoucherTwo.propTypes = {
    accountCreationDate: PropTypes.string,
    isMobileDevice: PropTypes.bool,
    onScrollTo: PropTypes.func,
    onDownloadContracts: PropTypes.func,
    onDownloadComponentPdf: PropTypes.func,
    onCallSurvey: PropTypes.func,
};

export default CardVoucherTwo;
